module.exports = __webpack_public_path__ + "img/playlist_icon.d354f534.svg";